import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MySnackbar from "../../../Components/MyComponents/MySnackbar";
import Authorize from "../../../../global/Authorize";
import Header from "../../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class SmsTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      smsTemplateData: [],
      snackbar: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Sms Template";
    this.fetchsmsTemp();
    this.setState({ snackbar: false });
  }

  fetchsmsTemp = () => {
    axios.get(`/api/smstemplate`, {}).then((res) => {
      this.setState({
        smsTemplateData: res.data,
      });
    });
  };

  handleCopy = (txt) => {
    navigator.clipboard
      .writeText(txt)
      .then(() => this.setState({ snackbar: true }));
  };
  render() {
    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header to="/home" title="SMS Template" />
        <div className="container mt-3 mb-5">
          <div className="th-black th-18 th-fw-600 text-center">
            SMS Template
          </div>
          <div>
            {this.state.smsTemplateData?.map((item) => {
              return (
                <div
                  key={item.id}
                  className="flex-column w-100 p-2 my-3 th-br-10"
                  style={{
                    boxShadow: "0px 1px 3px  grey",
                  }}
                >
                  <div className="d-flex justify-content-between pb-2">
                    <div className="th-12 th-fw-600 pt-1 th-primary">
                      {item.sms_name}
                    </div>
                    <div>
                      <div className="fa fa-copy th-grey th-12"></div>
                      <button
                        className=" th-bg-white th-12 th-grey"
                        onClick={() => this.handleCopy(item.sms_content)}
                        style={{ border: "0px" }}
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                  <div className="w-100 th-12">{item.sms_content}</div>
                </div>
              );
            })}
          </div>
        </div>
        {this.state.snackbar ? (
          <MySnackbar title="Sms Copied Successfully!" />
        ) : null}
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(SmsTemplate));
